export default __webpack_public_path__ + "static/media/inside.68db574d.mp3";